import { combineReducers } from 'redux';
import { consultationReducer } from './reducers/consultation';
import { flagsReducer } from './reducers/flags';
import { treatmentCategoriesReducer } from './reducers/treatmentCategories';
import { loginReducer } from './reducers/login';
import { sessionReducer } from './reducers/session';

const rootReducer = combineReducers({
  consultationReducer,
  flagsReducer,
  treatmentCategoriesReducer,
  loginReducer,
  sessionReducer,
});

export default rootReducer;
